var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExchangeCircled = function SvgExchangeCircled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "currentColor",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0982 18.6118C13.7685 18.6987 13.4682 18.3969 13.5577 18.0687L14.7591 13.6596C14.8479 13.3334 15.2561 13.2235 15.4974 13.4608L16.4063 14.3546C16.552 14.4979 16.7765 14.5218 16.9549 14.4218C19.8975 12.7711 23.6746 13.0959 26.2888 15.3964C26.4741 15.5595 26.4736 15.844 26.2976 16.017L25.6655 16.6386C25.4931 16.8081 25.217 16.8066 25.0332 16.6493C23.1966 15.0779 20.6494 14.7366 18.5041 15.6255C18.2282 15.7398 18.176 16.0949 18.3887 16.3041L18.7796 16.6885C19.024 16.9288 18.9135 17.343 18.5818 17.4304L14.0982 18.6118Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9019 21.3882C26.2315 21.3013 26.5318 21.603 26.4424 21.9313L25.241 26.3404C25.1521 26.6666 24.7439 26.7765 24.5026 26.5392L23.5937 25.6454C23.448 25.5021 23.2235 25.4782 23.0451 25.5782C20.1025 27.2289 16.3254 26.904 13.7112 24.6036C13.5259 24.4405 13.5264 24.156 13.7024 23.983L14.3345 23.3614C14.5069 23.1919 14.7831 23.1934 14.9668 23.3506C16.8034 24.9221 19.3507 25.2634 21.4959 24.3745C21.7718 24.2602 21.824 23.9051 21.6113 23.6959L21.2204 23.3115C20.976 23.0712 21.0865 22.657 21.4182 22.5696L25.9019 21.3882Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExchangeCircled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ExchangeCircled.416b685f03a83ea1d6cf7a82fc7effe1.svg";